module.exports = __webpack_public_path__ + "media/images/icons/twotone/bell-c02c0a23fb4cac7e2989894a17d1596a.svg";